import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { getHelpArticles } from "../../services/helpApi";

const useHelpArticles = ({ searchParam, categoryId, status, pageNumber, refreshKey }) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [articles, setArticles] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchArticles = async () => {
        try {
          const { data } = await getHelpArticles({
            searchParam,
            categoryId,
            status,
            pageNumber
          });

          setArticles(Array.isArray(data?.articles) ? data.articles : []);
          setHasMore(Boolean(data?.hasMore));
          setCount(typeof data?.count === 'number' ? data.count : 0);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchArticles();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, categoryId, status, pageNumber, refreshKey]);

  return { articles, loading, hasMore, count };
};

export default useHelpArticles;
